// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1cPTL","loadingShrink":"PageLoading_loadingShrink__c8tqG"};